import { PropsWithChildren } from 'react';
import { Heading } from 'ui-components';

export default function EmptyState({ children }: PropsWithChildren): React.ReactElement {
  return (
    <Heading variant="h4" className="font-thin font-aribau text-zinc-400 p-6">
      {children}
    </Heading>
  );
}
